module.exports = __webpack_public_path__ + "img/russland_von_oben_rus.f9e312d9.png";